var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"partial partial--auth partial--auth-reset auth-reset"},[_c('div',{staticClass:"auth-login__header"}),_c('div',{staticClass:"auth-login__body"},[_c('card',[_c('form-reset',{staticClass:"auth-reset__form"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }